// @ts-check
import { defineStore } from "pinia";

export const useCubbyStore = defineStore("cubby", {
  state: () => ({
    items: [],
    loading: false,
  }),
});
